<template>
  <div v-if="showForCompany">
    <span
      v-if="outOfStock"
      class="badge bg-danger"
      title="This product is stocked in this branch however we have no available inventory">
      <i class="fa fa-exclamation-triangle"/>
      Out of Stock in Home Branch
    </span>
    <span
      v-else-if="notStocked"
      class="badge bg-secondary"
      title="This product is not stocked in this branch">
      <i class="fa fa-times-circle"/>
      Not Stocked in Home Branch
    </span>
  </div>
</template>

<script>
  import { stockFlagInBranch } from '../../../../shared/stockHelpers'

  export default {
    props:['product'],
    computed:{
      sessionCompany(){return this.$store.getters.sessionCompany},
      showForCompany(){return ['Lancaster US', 'Merit Supply'].includes(this.sessionCompany)},
      homeBranch(){return this.$store.getters.homeBranch},
      stockFlagInBranch(){return stockFlagInBranch(this.product)},
      homeBranchRecord(){return _.find(this.product.eclipse_data?.branches, {id: this.homeBranch})},
      homeBranchAvail(){return this.homeBranchRecord ? parseInt(this.homeBranchRecord.avail) : 0},
      stockedInHomeBranch(){return !!(this.stockFlagInBranch && this.stockFlagInBranch.includes(this.homeBranch))},
      // Out of stock: product is flagged as a stock item in the home branch but has no available inventory there
      outOfStock(){
        return this.stockedInHomeBranch && this.homeBranchAvail == 0
      },
      // Not stocked: product is not flagged as a stock item in the home branch and has no available inventory there
      notStocked(){
        return !this.stockedInHomeBranch && this.homeBranchAvail == 0
      }
    }
  }
</script>
